import { Reveal } from "./Reveal";
import { buildWhatsAppLink } from "./WhatsAppButton";
import { useLang } from "../../i18n";

export function Reviews() {
  const { t } = useLang();
  const r = t.reviews;
  return (
    <section id="avis" className="px-6 py-28 lg:px-10 lg:py-36">
      <div className="mx-auto max-w-5xl">
        <div className="text-center">
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold">{r.eyebrow}</p>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="mt-4 font-display text-4xl italic sm:text-5xl">{r.title}</h2>
          </Reveal>
          <Reveal delay={180}>
            <div className="hairline mx-auto mt-6 w-16" />
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-3">
          <Reveal delay={80}>
            <div className="h-full border border-border bg-background px-8 py-8 text-center" data-testid="reviews-key-figure">
              <p className="font-display text-5xl italic text-gold">
                32<span className="text-2xl text-foreground/60"> / 37</span>
              </p>
              <p className="mt-3 text-sm text-foreground/80">{r.figureLabel}</p>
              <p className="mt-2 text-[10px] uppercase tracking-[0.22em] text-muted-foreground">{r.source}</p>
            </div>
          </Reveal>
          <Reveal delay={160}>
            <div className="h-full border border-border bg-background px-8 py-8 text-center" data-testid="reviews-score-personnel">
              <p className="font-display text-5xl italic text-gold">
                9,2<span className="text-2xl text-foreground/60"> / 10</span>
              </p>
              <p className="mt-3 text-sm text-foreground/80">{r.personnel}</p>
              <p className="mt-2 text-[10px] uppercase tracking-[0.22em] text-muted-foreground">{r.source}</p>
            </div>
          </Reveal>
          <Reveal delay={240}>
            <div className="h-full border border-border bg-background px-8 py-8 text-center" data-testid="reviews-score-situation">
              <p className="font-display text-5xl italic text-gold">
                9,3<span className="text-2xl text-foreground/60"> / 10</span>
              </p>
              <p className="mt-3 text-sm text-foreground/80">{r.situation}</p>
              <p className="mt-2 text-[10px] uppercase tracking-[0.22em] text-muted-foreground">{r.source}</p>
            </div>
          </Reveal>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {r.quotes.map((q, i) => (
            <Reveal key={q.name} delay={i * 100}>
              <div className="column-accent flex h-full flex-col border border-border bg-card p-8 pl-10" data-testid={`review-card-${i + 1}`}>
                <div className="flex items-center justify-between gap-4">
                  <p className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">{q.name}</p>
                  <span className="shrink-0 border border-gold/50 px-2.5 py-1 text-[10px] uppercase tracking-[0.18em] text-gold">
                    {q.score}
                  </span>
                </div>
                <p className="mt-5 font-display text-xl italic leading-relaxed text-foreground sm:text-2xl">
                  &laquo;&nbsp;{q.text}&nbsp;&raquo;
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={160}>
          <p className="mt-10 text-center text-xs text-muted-foreground" data-testid="reviews-source-note">
            {r.sourceNote}
          </p>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-10 text-center">
            <a
              href={buildWhatsAppLink(t.wa.generic)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-whatsapp-cta"
              className="inline-flex items-center border border-foreground px-8 py-4 text-[11px] uppercase tracking-[0.25em] transition hover:bg-foreground hover:text-background"
            >
              {r.cta}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
